import { useCallback } from 'react';

import {
    showError,
    showErrorRevamped,
    showInfo,
    showInfoRevamped,
    showSuccess,
    showWarning,
    showWarningRevamped
} from '@lib/utils/toast';

export type ToastLevel = 'success' | 'info' | 'warning' | 'error';

export interface ToastParams {
    message: string;
    level: ToastLevel;
    timeout?: number;
}

export const useToast = () => {
    const isUiRevampEnabled = true;
    const toast = useCallback(({ message, level, timeout = 2000 }: ToastParams) => {
        switch (level) {
            case 'success':
                if (isUiRevampEnabled) {
                    showInfoRevamped(message, timeout);
                    break;
                }
                showSuccess(message, timeout);
                break;

            case 'info':
                if (isUiRevampEnabled) {
                    showInfoRevamped(message, timeout);
                    break;
                }
                showInfo(message, timeout);
                break;

            case 'warning':
                if (isUiRevampEnabled) {
                    showWarningRevamped(message, timeout);
                    break;
                }
                showWarning(message, timeout);
                break;
            case 'error':
                if (isUiRevampEnabled) {
                    showErrorRevamped(message, timeout);
                    break;
                }
                showError(message, timeout);
                break;
        }
    }, []);

    return {
        toast
    };
};

export default useToast;
